class SessionsService {
  constructor(sessionsRepository) {
    this.sessionsRepository = sessionsRepository;
  }

  async getSessionsById(id) {
    return await this.sessionsRepository.getSessionsById(id);
  }

  async getSessionReport(id) {
    return await this.sessionsRepository.getSessionReport(id);
  }

  async getSessionBySectionId(id) {
    return await this.sessionsRepository.getSessionBySectionId(id);
  }

  async getSessionsByStudentId(id) {
    return await this.sessionsRepository.getSessionsByStudentId(id);
  }

  async updateSession(id, postData) {
    return await this.sessionsRepository.updateSession(id, postData);
  }

  async submitReadingReport(id, data) {
    return await this.sessionsRepository.submitReadingReport(id, data);
  }

  async submitAnswers(id, data) {
    return await this.sessionsRepository.submitAnswers(id, data);
  }

  async scoreAnswers(id, data) {
    return await this.sessionsRepository.scoreAnswers(id, data);
  }

  async evaluateSession(id) {
    return await this.sessionsRepository.evaluateSession(id);
  }

  async decideSession(id, data) {
    return await this.sessionsRepository.decideSession(id, data);
  }

  async getAssessmentProgress(studentId, classroomId) {
    return await this.sessionsRepository.getAssessmentProgress(
      studentId,
      classroomId
    );
  }
}
export default SessionsService;
